import { render, staticRenderFns } from "./ArticleProcess.vue?vue&type=template&id=2ff204ec&scoped=true&"
import script from "./ArticleProcess.vue?vue&type=script&lang=js&"
export * from "./ArticleProcess.vue?vue&type=script&lang=js&"
import style0 from "./ArticleProcess.vue?vue&type=style&index=0&id=2ff204ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff204ec",
  null
  
)

export default component.exports